import React from 'react';
import FancyButton from '../FancyButton';
import '../FancyButton.css';

interface LeaderboardButtonProps {
  onClick: () => void;
}

const LeaderboardButton: React.FC<LeaderboardButtonProps> = ({ onClick }) => {
  return (
    <div title="View Leaderboard (Press 'L' key)">
      <FancyButton
        onClick={onClick}
        variant="purple"
        className="stats-button"
      >
        LEADERBOARD
      </FancyButton>
    </div>
  );
};

export default LeaderboardButton;
